module.exports = __webpack_public_path__ + "img/wind-decoration-with-plants.8615c070.jpg";